import { Component, Input, OnInit } from '@angular/core';
import { NgRedux, Select, Select$ } from '@angular-redux3/store';

import { environment } from '../../../../environments/environment';
import { AAddTracksToPlaylist, ABlacklist, ADislike, ALike, AUnblacklist, PlaylistRemoteAppState } from '../../../store';
import { AssoMediaEvent, Blacklist, Media, PlayerStatus, Playlist, Tempo } from '../../../store/entities';
import { LibraryService } from '../../../containers/library/library.service';
import { Observable, of } from 'rxjs';
import { PlaybackDialogComponent } from '../../dialogs/playback-dialog/playback-dialog.component';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { AudioService } from '../../../services/audio.service';
import { TranslateService } from '@ngx-translate/core';
import { extractPropertyFromArray, isItemInArray } from 'src/app/utils';
import { SyncDialogService } from 'src/app/services/sync-dialog.service';

@Component({
  selector: 'mwo-track',
  templateUrl: './track.component.html',
  styleUrls: ['./track.component.scss']
})
export class TrackComponent implements OnInit {
  @Input() item: (AssoMediaEvent | Blacklist) & { isWaitlist?: boolean };
  @Input() mode = 'playlist';
  @Input() isCurrent = false;
  @Input() isNew = false;
  playlist: Playlist = {};
  coverUrl = 'assets/icons/default_icon.webp';
  coverPlaylist = 'assets/icons/default_icon.webp';
  @Select(['player', 'event']) event$: Observable<Playlist>;
  @Select(['player', 'tempo']) tempo$: Observable<Tempo>;
  @Select(['player', 'timeSlot']) timeslot$: Observable<Tempo>;
  // Using the same code from the player component
  @Select$('blacklist', extractPropertyFromArray('media')) blacklist$: Observable<Media[]>;
  @Select('wishlist') wishlist$: Observable<Playlist>;
  // @ts-ignore
  isInWishlist$: Observable<boolean>;
  // @ts-ignore
  isInBlacklist$: Observable<boolean>;

  playerId: string;
  isPlaying: boolean;
  media: Media;
  protected readonly environment = environment;
  private dialogRef: MatDialogRef<PlaybackDialogComponent, any>;

  constructor(
    private ngRedux: NgRedux<PlaylistRemoteAppState>,
    private libraryService: LibraryService,
    private audioService: AudioService,
    private translate: TranslateService,
    public dialog: MatDialog,
    private syncDialogService: SyncDialogService,
  ) {
  }

  ngOnInit() {

    this.ngRedux.select<PlayerStatus>('player').subscribe(({ isPlaying, media }) => {
      if (isPlaying && media) {
        this.isPlaying = isPlaying && (!this.item?.media || this.item?.media.id === media.id);
      } else {
        this.isPlaying = false;
      }
    });
    console.log('this.item', this.item)

    if (!this.item.media) {
      this.media = this.item;
    } else {
      this.media = this.item.media;
    }

    let itemId = '';
    if ('title' in this.item) {
      if (this.item.media && this.item.media.album.artwork) {
        this.coverUrl = this.item.media.album.artwork;
      } else if (this.item.media && this.item.media.album) {
        this.coverUrl = `${environment.remoteApi}/${environment.apiVersion}/media/artwork/${this.item.media.id}`;
      } else if (this.item.album && this.item.album.artwork) {
        this.coverUrl = this.item.album.artwork;
      } else {
        this.coverUrl = `${environment.remoteApi}/${environment.apiVersion}/media/artwork/${this.item.id}`;
      }
      if (this.item && this.item.event) {
        this.coverPlaylist = this.item.event.artwork;
      } else if (this.item && this.item.tempo) {
        this.coverPlaylist = this.item.tempo.artwork;
      }
    } else {
      this.coverUrl = `${environment.remoteApi}/${environment.apiVersion}/media/artwork/${this.item.id}`;
    }

    if (this.item.media) {
      itemId = this.item.media.id;
    } else if (this.item && 'tempo' in this.item && this.item.tempo) {
      itemId = this.item.tempo.id;
    }

    if (this.mode === 'history') {
      this.blacklist$.subscribe(blacklist => {
        this.isInBlacklist$ = of(
          blacklist && blacklist.length > 0 && blacklist.some(i => i.id === itemId)
        );
      });

      this.wishlist$.subscribe(wishlist => {
        this.isInWishlist$ = of(
          wishlist && wishlist.assoMediaEvent.length > 0 && wishlist.assoMediaEvent.some(i => i.media?.id === itemId)
        );
      });
    }
  }

  addToPlaylist(assoMediaEvent: AssoMediaEvent, isNew = false): void {
    this.libraryService.openPlaylistPicker(isNew).subscribe(playlist => {
      this.ngRedux.dispatch(AAddTracksToPlaylist({ assoMediaEvent: [assoMediaEvent], playlistId: playlist.id }));
    });
  }

  like(media: Media) {
    this.ngRedux.dispatch(ALike({ media }));
    this.ngRedux.dispatch(AUnblacklist(media.id));
    if (!environment.enableDesktopMode) {
      this.syncDialogService.openSyncDialog();
    }
  }

  blacklist(media: Media) {
    this.ngRedux.dispatch(ABlacklist({ id: media.id, media, blacklistDate: new Date().getTime() }));
    this.ngRedux.dispatch(ADislike(media.id));
    if (!environment.enableDesktopMode) {
      this.syncDialogService.openSyncDialog();
    }
  }

  unlike(media: Media) {
    this.ngRedux.dispatch(ADislike(media.id));
    if (!environment.enableDesktopMode) {
      this.syncDialogService.openSyncDialog();
    }
  }

  getImage(item) {
    return `${environment.remoteApi}/${environment.apiVersion}/media/artwork/${item.id}`;
  }

  unblacklist(event) {
    event.stopPropagation();
    event.preventDefault();
    this.ngRedux.dispatch(AUnblacklist(this.media.id));
  }

  playback(item: any) {
    this.dialogRef = this.dialog.open(PlaybackDialogComponent, {
      disableClose: false,
      data: {
        title: this.translate.get('dialog.playback'),
        spinner: false,
        isPassivePlayback: true,
        id: item.id
      }
    });

    this.dialogRef.afterClosed().subscribe(() => {
      this.audioService.pauseAudio();
    });
  }
}
